import { Box, Loading } from 'pixelize-design-library';

import { useAppTheme } from '@core/Theme/useAppTheme';
import { canvas } from '@core/Theme/tokens';

interface LoadingFallbackProps {
  text?: string;
  minH?: string;
}

/** The single full-surface pending state: route suspense, and any guard still resolving. */
export function LoadingFallback({ text, minH = '60vh' }: LoadingFallbackProps) {
  const { colors } = useAppTheme();

  return (
    <Box
      minH={minH}
      w='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
      bg={canvas(colors)}
      data-testid='loading-fallback'
    >
      <Loading isLoading text={text} />
    </Box>
  );
}
